module.exports = __webpack_public_path__ + "static/media/email.79d98763.svg";